module.exports = __webpack_public_path__ + "img/close@3x.b16bfd87.png";